import { Pipe, PipeTransform } from '@angular/core';

import { GridstackHeaderItem } from '@models/common';

@Pipe({
  name: 'gridstackHeaderOptions',
})
export class GridstackHeaderPipe implements PipeTransform {
  transform(item: GridstackHeaderItem, ...args: any[]): any {
    return { ...item, id: item.id.toString() };
  }
}
